<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
import "@/assets/scss/element-style-1.scss"
import "@/assets/scss/element-style.scss"
export default {
	name: 'home',
	data() {
		return {

		}
	},
}

</script>

<style lang="scss" >
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif !important;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	// text-align: center;
	background: #F2F5FB;
	color: #2c3e50;
}

::-webkit-scrollbar {
	width: 7px;
	height: 7px;
}

::-webkit-scrollbar-thumb {
	border-radius: 5px;
	background: #C2C8D5;
}

::-webkit-scrollbar-track {
	border-radius: 10px;
	background: #EFF1F5;
}

.hover {
	cursor: pointer !important;
}

.disabled {
	cursor: not-allowed;
}

* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	// -webkit-user-select: none;
	// -moz-user-select: none;
	// user-select: none;
	// -ms-user-select: none;
}

img {
	font-size: 0;
	vertical-align: middle;
}
.public-dia{
  .el-dialog__header{
    padding: 0px;

  }
  .el-dialog__body{
    padding: 20px 36px 0px 36px;
  }
  .el-dialog__footer{
    padding: 2px 36px 26px 36px;
    .dialog-footer{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .qx{
        padding: 7px 23px;
        font-size: 14px;
        font-weight: 400;
        border-radius: 4px;
        line-height: 16px;
        border: 1px solid #E2E7EE;
        cursor: pointer;
        color: #4D535C;
        margin-right: 10px;
      }
      .qx:hover{
        color: #1D78FE;
        border-color: #1D78FE;
      }
      .qd{
        padding: 7px 23px;
        font-size: 14px;
        font-weight: 400;
        border-radius: 4px;
        line-height: 16px;
        background-color: #1D78FE;
        border: 1px solid #1D78FE;
        cursor: pointer;
        color: #FFFFFF;
      }
      .qd:hover{
        background-color: #3486ff;
        border-color: #3486ff;
      }
    }
  }
}
.public-dia-header{
  padding: 26px 20px 14px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #F0F1F5;
  .public-dia-header-title{
    font-size: 16px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: bold;
    color: #2E3139;
    line-height: 16px;
  }
}
.public-hov{
  font-size: 14px !important;
}
.public-hov:hover{
  color: #1D78FE !important;
}
.public-form .el-form-item__label{
  padding: 0px 16px 0px 0px;
  color: #4D535C;

}
.public-form .el-form-item{
  margin-bottom: 12px;
}
.public-form .el-form-item__error{
  padding-top: 0px;
}

// @import "@/assets/scss/formstyle.scss"
</style>
